import React from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from './components/Routes/PrivateRoute';
import PublicRoute from './components/Routes/PublicRoute';

import useApp from './hooks/useApp';
import ErrorPage from './components/ErrorPage';
import ConfigureTest from './components/Onboarding/ConfigureTest';
import ConfigureTestYamlBased from './components/Onboarding/ConfigureTestYamlBased';
import Loader from 'components/Loader';
// eslint-disable-next-line
import ComponentTraceLoader from 'components/ComponentTraceLoader';

import Artifacts from 'pages/artifacts';

import { Path } from 'constants/routes';

const PRIVATE_TYPE = 'private';
const PUBLIC_TYPE = 'public';

const Privacy = React.lazy(() => import('./components/Privacy'));

const HyperExecute = React.lazy(() =>
  import(/* webpackPrefetch: true */ './components/HyperExecute')
);

const DesignSystem = React.lazy(() => import('./components/DesignSystem'));

const HypertestJobDetail = React.lazy(() =>
  import('./components/HypertestJobDetail')
);

const HomePage = React.lazy(() => import('./components/Onboarding/HomePage'));

const TrialUserPage = React.lazy(() => import('./components/TrialUserPage'));

// const ConfigureTest = React.lazy(() =>
//   import('./components/Onboarding/ConfigureTest')
// );

// const ConfigureTestYamlBased = React.lazy(() =>
//   import('./components/Onboarding/ConfigureTestYamlBased')
// );

const ExcludeExactMatchRoutes = [Path.HYPEREXECUTE, Path.JOBS];

const routes = [
  {
    path: ['/', '/v2/:tab'],
    type: PRIVATE_TYPE,
  },
  {
    path: Path.TASK,
    Component: HypertestJobDetail,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.ARTIFACT.WithParam,
    Component: Artifacts,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.HYPEREXECUTE,
    Component: HyperExecute,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.PRIVACY,
    Component: Privacy,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.DESIGN_SYSTEM,
    Component: DesignSystem,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.QUICK_START,
    Component: HomePage,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.TRY_NOW,
    Component: TrialUserPage,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.ONBOARD,
    Component: TrialUserPage,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.QUICK_START_CONFIGURE_TEST.WithParam,
    Component: ConfigureTest,
    type: PUBLIC_TYPE,
  },
  {
    path: Path.QUICK_START_YAML_BASED_TEST.WithParam,
    Component: ConfigureTestYamlBased,
    type: PUBLIC_TYPE,
  },
  {
    path: '/*',
    Component: ErrorPage,
    type: PUBLIC_TYPE,
  },
];

const Routes = ({ children }) => {
  const { userInfo = {}, orgPreference = {} } = useApp();

  const { loading: userInfoLoading = false, data: userInfoData } = userInfo;

  const { loading: opLoading, error: opError } = orgPreference;

  const isThingsLoading =
    userInfoLoading || !userInfoData || opLoading || opError === null;

  if (isThingsLoading) {
    return <Loader isSuspenseLoader={true} />;
  }

  return <>{children}</>;
};

const RouteWrapper = () => {
  return (
    <Routes>
      <Switch>
        {routes.map(({ path, Component, type, ...props }) => {
          if (type === PUBLIC_TYPE)
            return (
              <PublicRoute
                key={path}
                component={Component}
                path={path}
                exact={!ExcludeExactMatchRoutes.includes(path)}
                {...props}
              />
            );
          if (type === PRIVATE_TYPE)
            return (
              <PrivateRoute
                key={path}
                component={Component}
                path={path}
                exact
                {...props}
              />
            );
          return path;
        })}
      </Switch>
    </Routes>
  );
};

export default RouteWrapper;
